<!-- display-mobile-02 preview — in-article display ad on a publisher page -->
<app-mobile-frame>
  <app-display-browser-chrome frameTop></app-display-browser-chrome>

  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- Article text the ad is embedded in -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of topBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>

    <!-- START: Real ad -->
    <div class="da-ad">
      <i class="bi bi-info-circle da-adchoices"></i>

      <div class="da-ad-row d-flex flex-row">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing" [title]="missingDimensionLabel">{{ missingDimensionShortLabel }}</div>
        </a>

        <div class="da-copy">
          <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
            {{ data.headlines[0] || "Your headline appears here" }}
          </a>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <div class="da-footer d-flex flex-row align-items-center">
            <span class="da-badge">Ad</span>
            <span class="da-advertiser">Valamar</span>
            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta ms-auto">
              {{ data.ctaText || "Your call to action" }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- Article text continuing below the ad; the last rows clip at the frame -->
    <div class="da-bars d-flex flex-column">
      <span *ngFor="let bar of bottomBars" class="da-bar placeholder"></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
